/* Maison Store reviews, keyed by product handle. Each entry: [name, rating, date, variant, text].
   These are verified-purchase reviews from Valenzza, our sister store, and are labeled as such on the page.
   Add Maison's own reviews here after checking each one against a real order. */
window.MAISON_REVIEWS = {
 "9060-limited-edition-voices": [
  [
   "Stacey M.",
   4,
   "2026-07-29",
   "Pink Baby Shower",
   "Beautiful sneakers. Fits true to size"
  ]
 ],
 "9060-pink-overdye-copia": [
  [
   "Roxanne M.",
   5,
   "2026-06-20",
   "Pink Overdye",
   "Live them beautiful color i love pink"
  ]
 ],
 "cloudtilt-womens": [
  [
   "Georgina P.",
   5,
   "2026-09-04",
   "Black and White",
   "Spectacular, I recommend them, I get there on time, it’s a very good product."
  ],
  [
   "Ellie R.",
   5,
   "2026-08-10",
   "Red",
   "So cute"
  ]
 ],
 "new-balance-530-polka-silver-dots": [
  [
   "Veronica C.",
   5,
   "2026-08-27",
   "Silver Polk Dots",
   "I love them !!"
  ],
  [
   "Kerry M.",
   5,
   "2026-08-26",
   "Silver Polk Dots",
   "Shoes were good quality. Sizing was off, but really great customer service experience. Let me return. Buy with confidence!"
  ],
  [
   "Priscila E.",
   5,
   "2026-08-20",
   "Silver Polk Dots",
   "Super cute, conformtable, light weight shoes. Delivered in time and you can track it all the way. I love my new shoes and recommend it 100%"
  ],
  [
   "Wanda S.",
   5,
   "2026-08-07",
   "Silver Polk Dots",
   "These are so cute and i get lots of compliments but should note that they run small, I'm a true 7.5 and had to exchange for an 8.5, their customer service is great but shipping is on the slow side."
  ],
  [
   "Letícia B.",
   5,
   "2026-08-06",
   "Silver Polk Dots",
   "Guys, I absolutely love this store! I found them through Instagram, and I’m so glad I did — I had some questions about the sizing before ordering, and they were incredibly kind, patient, and helpful. They answered everything and made me feel confident about my purchase. — My sneakers arrived quickly, and I was honestly impressed. The quality is amazing, the shoes are impeccable, and they have so many beautiful colors to choose from. — I’m so happy with my purchase, and from now on I’ll definitely be buying all my sneakers from them. I highly recommend this store!"
  ],
  [
   "Michelle O.",
   5,
   "2026-07-17",
   "Silver Polk Dots",
   "Quick shipping love my shoes"
  ],
  [
   "Casey W.",
   5,
   "2026-07-11",
   "Silver Polk Dots",
   "Order came promptly and everything was expected"
  ],
  [
   "Shannon F.",
   5,
   "2026-07-09",
   "Silver Polk Dots",
   "Fit great and super cute!"
  ],
  [
   "shannon g.",
   5,
   "2026-07-08",
   "Silver Polk Dots",
   "The shoes are perfect!"
  ],
  [
   "Shannon A.",
   5,
   "2026-06-30",
   "Silver Polk Dots",
   "Super cute and comfy if you have time to wait for them. Arrival time is about 3 weeks. Definitely worth the wait!"
  ],
  [
   "Kaytlynn F.",
   5,
   "2026-06-26",
   "Silver Polk Dots",
   "Perfect:) took about a month to come in, company was fast and friendly to email!"
  ]
 ],
 "nb-9060-bisque-with-sea-salt": [
  [
   "thays B.",
   5,
   "2026-08-03",
   "Bisque with Sea Salt",
   "After reading some reviews, I was a bit worried about ordering, but I trusted the store and I’m so happy I did! The shoes are amazing, exactly what I was hoping for, and the quality is excellent. The customer service was outstanding, answered every question I had and made me feel confident throughout the entire process. I absolutely love my purchase and will definitely be back! ⭐⭐⭐⭐⭐"
  ],
  [
   "Maria Q.",
   5,
   "2026-07-23",
   "Bisque with Sea Salt",
   "Estan Perfectos"
  ]
 ],
 "nb-9060-black-cat": [
  [
   "Shuana N.",
   5,
   "2026-08-27",
   "Black Cat",
   "Beautiful color, comfy fit, so far, great for walking, very stylish."
  ]
 ],
 "nb-9060-brown-ice": [
  [
   "Liliana H.",
   5,
   "2026-08-08",
   "US 8.5 M",
   "🥰🥰🥰🥰"
  ]
 ],
 "nb-9060-mono-cortado": [
  [
   "Juergen G.",
   4,
   "2026-07-24",
   "Cortado",
   "Lieferzeit lange"
  ]
 ],
 "nb-9060-oxfordblue": [
  [
   "Sophia C.",
   5,
   "2026-08-29",
   "Oxford Blue",
   "Love’em"
  ],
  [
   "Sharon E.",
   5,
   "2026-08-26",
   "Triple White",
   "I like them very much!"
  ],
  [
   "Migdalia O.",
   5,
   "2026-08-03",
   "Triple White",
   "I don't have pictures I had to send them back They ran small"
  ],
  [
   "Santa R.",
   5,
   "2026-07-21",
   "Triple White",
   "Me encantó 💕 😍 hermoso"
  ]
 ],
 "nb-9060-summer-mule-off-white-mauve": [
  [
   "Ralph I.",
   5,
   "2026-07-01",
   "Off White Mauve",
   "Shoes are fire. The delivery process was HORRIBLE!!!"
  ]
 ],
 "nb-9060-triple-white": [
  [
   "Alexandre P.",
   5,
   "2026-08-27",
   "Triple White",
   "Amazing shoes, great and comfortable for all day wear. Valenzza is a great store, arrived quickly"
  ],
  [
   "Katherine B.",
   5,
   "2026-07-25",
   "Triple White",
   "Love them🫠"
  ]
 ],
 "puma-ballet-lace-burgundy-ivory-edition-copy-1": [
  [
   "Lindsey B.",
   3,
   "2026-07-13",
   "OG Leather",
   "Cute but counterfeit, as the last reviewer also stated. I got a discount so I don’t feel like it was that bad of a deal but would not repurchase also took over a month to arrive. Clearly from China."
  ],
  [
   "Vanessa M.",
   5,
   "2026-06-05",
   "OG Leather",
   "Estan bonitos pero vienen mas grandes"
  ]
 ],
 "samba-jane-gs-trainers-white-beige": [
  [
   "Susy M.",
   5,
   "2026-08-24",
   "Frill Ruffle Pack",
   "Beautiful! Took a while to come in, but worth it!"
  ],
  [
   "Shannon B.",
   5,
   "2026-08-07",
   "Frill Ruffle Pack",
   "I love these shoes. They’re super cute. They’re very comfortable."
  ],
  [
   "Amanda S.",
   5,
   "2026-07-28",
   "Frill Ruffle Pack",
   "Excellent service and samba Jane are fabulous"
  ],
  [
   "Jennifer M.",
   5,
   "2026-07-28",
   "Frill Ruffle Pack",
   "Very cute. Great quality. Shipping took a few weeks but I’m happy with my purchase."
  ],
  [
   "Margaret A.",
   3,
   "2026-07-24",
   "Frill Ruffle Pack",
   "Beautiful shoes. Unfortunately I followed the advice on the website and went down a size but found them a little small. Haven’t returned as hopefully they will stretch slightly on wearing."
  ],
  [
   "Sharon T.",
   5,
   "2026-07-16",
   "Frill Ruffle Pack",
   "Very pleased with the shoes comfortable to wear and a lovely style. Very pleased with the service and delivery of them. Will definitely buy from them again"
  ],
  [
   "Judith M.",
   5,
   "2026-07-11",
   "Frill Ruffle Pack",
   "Lovely comfortable shoes that go with as anything."
  ],
  [
   "Michele H.",
   4,
   "2026-07-10",
   "Frill Ruffle Pack",
   "Show is beautiful, but I think I need. 1/2 bigger. I went but the measurements on the website."
  ],
  [
   "STACEY O.",
   5,
   "2026-07-07",
   "Frill Ruffle Pack",
   "So comfy and very versatile wear"
  ],
  [
   "Julie R.",
   5,
   "2026-07-06",
   "Frill Ruffle Pack",
   "These shoes are adorable! They are exactly as pictured and they fit great. My feet are narrow so I’m glad I sized down a 1/2 size."
  ],
  [
   "Stacey O.",
   5,
   "2026-07-05",
   "Frill Ruffle Pack",
   "So comfy and look so smart"
  ],
  [
   "Flora W.",
   5,
   "2026-07-03",
   "Frill Ruffle Pack",
   "Ordered this item didn’t take long for delivery kept up to date with tracking overall a good experience"
  ],
  [
   "Linda a.",
   5,
   "2026-07-03",
   "Frill Ruffle Pack",
   "🩷"
  ],
  [
   "Jacqueline K.",
   5,
   "2026-07-02",
   "Frill Ruffle Pack",
   "Great 🥰"
  ],
  [
   "Rachael M.",
   5,
   "2026-07-01",
   "Frill Ruffle Pack",
   "Love them"
  ],
  [
   "Renae S.",
   5,
   "2026-06-30",
   "Frill Ruffle Pack",
   "Lovely great"
  ],
  [
   "Najma A.",
   5,
   "2026-06-29",
   "Frill Ruffle Pack",
   "I love my Samba Jane frills. They fit really well and are extremely comfortable. I am already thinking about ordering a different pair. Delivery was quick and communication was efficient!"
  ],
  [
   "Danielle B.",
   5,
   "2026-06-05",
   "Frill Ruffle Pack",
   "De schoen is prachtig , en alles is soepel en goed verlopen zelfs al voordat de bestelling plaats vondt top gewoon!!"
  ]
 ],
 "samba-jane-wmns-green-white-gum-162581": [
  [
   "Ana caroline A.",
   5,
   "2026-08-15",
   "US 4 M",
   "I loved it so much!!!! Beautiful, comfortable exactly as I expected. I already want other colors!"
  ]
 ],
 "tasman-ii-original-edition-copy": [
  [
   "Priscila G.",
   5,
   "2026-08-23",
   "Rocky Oak",
   "Delivered at the expected time, with tracking number. Shoes are so comfortable and warm, the fur inside it doesn’t shed or come off . True to size. I’m ready for winter. I recommend it 100%."
  ]
 ],
 "vomero-premium": [
  [
   "Ana caroline A.",
   5,
   "2026-08-15",
   "Blue Tint",
   "I loved it! Very comfortable and beautiful! Perfect for doing sports and beautiful to go out."
  ],
  [
   "Rennan M.",
   5,
   "2026-08-06",
   "Coconut Milk – Total Orange",
   "Quality, comfort and fast delivery"
  ]
 ]
};

/* Label shown on every review and next to the review count. */
document.querySelectorAll('[data-mz-reviews]').forEach(function (root) {
  if (!root.dataset.sourceLabel) root.dataset.sourceLabel = 'Reviewed at Valenzza';
  if (!root.dataset.summarySuffix) root.dataset.summarySuffix = 'from Valenzza, our sister store';
});